import React from 'react';
import { IconProps } from '.';

const SvgDocumentDetails = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M1.75 1.75v19.5H8.5v-1.5H3.25V3.25h14.5v3.9h1.5v-5.4H1.75Z' />
      <path
        fill={color}
        d='M5.5 7.25h10v-1.5h-10v1.5ZM5.5 11.25h3v-1.5h-3v1.5ZM13.1 15.7a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4ZM15.1 15.7a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4ZM17.8 15a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M18.68 19.74a6 6 0 1 1 1.06-1.06l3.79 3.79-1.06 1.06-3.79-3.79ZM19.5 15a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgDocumentDetails;
